import "@fontsource/dm-sans"
import "@fontsource/dm-sans/500.css"
import "@fontsource/dm-sans/700.css"
import "@fontsource/dm-mono"
import "@fontsource/dm-mono/500.css"

// Client-side error suppression - runs as early as possible
export const onClientEntry = () => {
    // Enhanced client-side error suppression
    const originalError = console.error;
    console.error = function (...args) {
        const message = args[0]?.toString() || '';
        const stack = args[1]?.stack || '';

        if (
            message.includes('blocked a frame') ||
            message.includes('cross-origin') ||
            message.includes('app.cal.com') ||
            message.includes('Minified React error #418') ||
            message.includes('418') ||
            message.includes('hydrat') ||
            message.includes('1px.png') ||
            message.includes('usercentrics') ||
            message.includes('object o') ||
            message.includes('[object o]') ||
            message.includes('Content Security Policy') ||
            message.includes('frame-ancestors') ||
            message.includes('CSP') ||
            message.includes('webkitStorageInfo') ||
            message.includes('deprecated') ||
            message.includes('has not been added to the allow list') ||
            message.includes('Usercentrics') ||
            message.includes('graceful-elf-87e463.netlify.app') ||
            stack.includes('reportError') ||
            stack.includes('87c73c54-7ae8281e0b384267.js') ||
            stack.includes('48598-5f85b6d0a4fb59c2.js') ||
            stack.includes('BookingPageTagManager') ||
            stack.includes('embed.js')
        ) {
            return; // Suppress these specific errors
        }

        originalError.apply(console, args);
    };

    const originalWarn = console.warn;
    console.warn = function (...args) {
        const message = args[0]?.toString() || '';

        if (
            message.includes('markdownToSafeHTML should not be imported') ||
            message.includes('createWithEqualityFn instead of create') ||
            message.includes('react-i18next:: You will need to pass in an i18next instance') ||
            message.includes('was preloaded using link preload but not used') ||
            message.includes('hydrat') ||
            message.includes('418')
        ) {
            return; // Suppress these specific warnings
        }

        originalWarn.apply(console, args);
    };

    // Usercentrics wird bereits via gatsby-ssr.js im Head geladen
    // Hier nur Consent Mode Updates für GTM

    // Debug: Log wenn Usercentrics nicht lädt (z.B. auf localhost)
    setTimeout(() => {
        if (!window.UC_UI) {
            console.warn('[USERCENTRICS] Banner erscheint nicht - möglicherweise localhost nicht in Usercentrics konfiguriert')
            console.log('[USERCENTRICS] Für lokale Tests: Füge "localhost:9000" zu den erlaubten Domains in Usercentrics Admin hinzu')
            console.log('[USERCENTRICS] Oder teste auf der Live-Domain')
        }
    }, 3000)

    // Consent initial prüfen nach UC Initialisierung
    window.addEventListener('UC_UI_INITIALIZED', function () {
        console.log('[UC_UI_INITIALIZED] Usercentrics geladen')

        if (window.UC_UI) {
            const consentStatus = window.UC_UI.getServicesBaseInfo();
            const analyticsService = consentStatus.find(service =>
                service.name === 'Google Analytics' ||
                service.id === 'google-analytics' ||
                service.categorySlug === 'analytics'
            );

            // Wenn User bereits Consent gegeben hat, update Consent Mode
            if (analyticsService && analyticsService.consent?.status) {
                if (window.gtag) {
                    window.gtag('consent', 'update', {
                        analytics_storage: 'granted'
                    });
                    console.log('[CONSENT] Analytics consent granted (initial)')
                }
            }
        }
    });

    // Lausche auf Consent-Änderungen (Accept/Deny)
    // Verhindere Doppel-Ausführung durch Flag
    let consentHandled = false;

    window.addEventListener('UC_UI_CMP_EVENT', function (event) {
        if (!event.detail) return;

        const type = event.detail.type;
        console.log('[UC_UI_CMP_EVENT]', type)

        // Verhindere Doppel-Ausführung
        if (type === 'ACCEPT_ALL' && consentHandled) {
            console.log('[UC_UI_CMP_EVENT] Already handled, skipping');
            return;
        }

        if (type === 'ACCEPT_ALL') {
            consentHandled = true;
            // Reset nach 2 Sekunden
            setTimeout(() => { consentHandled = false; }, 2000);
        }

        // Google Consent Mode: Update je nach User-Entscheidung
        if (!window.gtag) {
            console.warn('[CONSENT] gtag not available yet')
            return
        }

        if (type === 'ACCEPT_ALL') {
            // User hat Analytics erlaubt - OHNE ad_storage etc. (Usercentrics managed das)
            window.gtag('consent', 'update', {
                analytics_storage: 'granted'
            });
            console.log('[CONSENT] Analytics consent granted')

            // Trigger GTM Event für zusätzliche Sicherheit
            window.dataLayer.push({
                'event': 'consent_granted',
                'consent_type': 'analytics'
            });
        } else if (type === 'DENY_ALL' || type === 'REJECT_ALL') {
            // User hat Analytics abgelehnt
            window.gtag('consent', 'update', {
                analytics_storage: 'denied'
            });
            console.log('[CONSENT] Analytics consent denied')

            // Lösche GA Cookies
            deleteGoogleAnalyticsCookies();
        }
    });

    // Funktion zum Löschen von Google Analytics Cookies
    function deleteGoogleAnalyticsCookies() {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.startsWith('_ga') || cookie.startsWith('_gid') || cookie.startsWith('_gat')) {
                const cookieName = cookie.split('=')[0];
                document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
            }
        }
        console.log('[CONSENT] GA Cookies deleted')
    }

    // Cal.com Floating Button - Globale Initialisierung
    // Nur einmal beim initialen Laden, nicht bei jeder Navigation
    if (typeof window !== 'undefined' && !window.__calcomInitialized) {
        window.__calcomInitialized = true;

        import("@calcom/embed-react").then(({ getCalApi }) => {
            getCalApi({ namespace: "aufbautermin" })
                .then((cal) => {
                    cal("floatingButton", {
                        calLink: "katisfotobox/aufbautermin",
                        buttonText: "Termin unverbindlich anfragen",
                        hideButtonIcon: false,
                        buttonColor: "#2C2C2C",
                        buttonTextColor: "#FFFFFF"
                    });
                    cal("ui", {
                        hideEventTypeDetails: false,
                        layout: "month_view"
                    });

                    // Safari-Kompatibilität: Button-Sichtbarkeit sicherstellen
                    setTimeout(() => {
                        const button = document.querySelector('[data-cal-namespace="aufbautermin"]');
                        if (button) {
                            button.style.cssText = `
                                position: fixed !important;
                                z-index: 9999 !important;
                                bottom: 20px !important;
                                right: 20px !important;
                            `;
                        }
                    }, 1000);
                })
                .catch((error) => {
                    console.warn('Cal.com konnte nicht geladen werden:', error);
                });
        }).catch((error) => {
            console.warn('Cal.com Modul konnte nicht importiert werden:', error);
        });
    }
};
